import { schemes } from "@zeal/common";
import { z } from "zod";

export const deleteFinixCardRequestSchema = z.object({
  customerAccountID: schemes.uuid(),
  cardID: z.string(),
});

export type TDeleteFinixCardRequestSchema = z.infer<
  typeof deleteFinixCardRequestSchema
>;
